import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { FormattedValueComponent } from "./formatted-value.component";

@NgModule({
  imports: [CommonModule, UiTooltipModule],
  declarations: [FormattedValueComponent],
  exports: [FormattedValueComponent],
})
export class FormattedValueModule {}
